import React from "react";
import isEmail from "validator/lib/isEmail";
import { connect } from "react-redux";
import * as resActions from "../../modules/resources";
import PropTypes from "prop-types";
import { alertSuccess } from "../../utils/alerts";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import { formatServerErrors } from "Utils/serverFormats";
import t from "Utils/translation";
import Stepper from "Components/stepper2/Stepper";
import Step1 from "./add_form/Step1.jsx";
import Step2 from "./add_form/Step2.jsx";
import Step3 from "./add_form/Step3.jsx";
import Step4 from "./add_form/Step4.jsx";
import Step5 from "./add_form/Step5.jsx";

const propTypes = {};

const ContextTypes = {
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  getLoggedUserType: PropTypes.func
};

const formInitialState = {
  firstname: "",
  lastname: "",
  company: "",
  password: "",
  password_confirmation: "",
  email_address: "",
  customer_code: undefined
};

class TeamMemberNewScreen extends React.Component {
  constructor(props) {
    super(props);
    this.fillPasswordFields = this.fillPasswordFields.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.goToStep = this.goToStep.bind(this);
    this.goBack = this.goBack.bind(this);
    this.backToList = this.backToList.bind(this);
    this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.state = {
      permissions: [],
      currentStep: 1,
      steps: {
        1: { component: <Step1 /> },
        2: { component: <Step2 /> },
        3: { component: <Step3 /> },
        4: { component: <Step4 /> },
        5: { component: <Step5 /> }
      },
      domainRelatedPermissions: [
        "create_domains",
        "disable_domains",
        "edit_email_accounts",
        "create_email_accounts",
        "disable_email_accounts",
        "create_vault_email_accounts",
        "disable_vault_email_accounts",
        "delete_vault_email_accounts",
        "delete_domains",
        "delete_email_accounts",
        "change_email_accounts_pwd",
        "manage_managers"
      ],
      archiveRelatedPermissions: [
        "create_vault_email_accounts",
        "disable_vault_email_accounts",
        "delete_vault_email_accounts",
        "manage_vault_delegate",
        "disable_vault_delegate"
      ]
    };
  }

  componentDidMount() {
    this.getPermissions();
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  backToList() {
    this.props.history.push("/team_members");
  }

  getPermissions() {
    const api = new QboxmailApi({ useCookie: true });
    api
      .getPermissions()
      .then(resp => {
        this.setState({ permissions: resp.resources });

        resp.resources.forEach(perm => {
          this.props.setFormFieldValue({ [perm.name]: true });
        });
      })
      .catch(err => {
        console.error("Error getting permissions:", err);
      });
  }

  validate(data) {
    let errors = {};
    let values = Object.assign({}, data);
    const requiredFields = ["password", "password_confirmation", "firstname", "lastname"];
    for (let i = 0; i < requiredFields.length; i++) {
      if (!values[requiredFields[i]]) errors[requiredFields[i]] = "is required";
    }
    if (values.password.length < 8) errors.password = "is too short";
    if (values.password !== values.password_confirmation) {
      errors.password_confirmation = "is not the same";
    }

    if (!isEmail(values.email_address)) {
      errors.email_address = "is not valid";
    }

    let permissions = [];
    this.state.permissions.forEach(perm => {
      if (values[perm.name]) permissions.push(perm.name);
      delete values[perm.name];
    });

    if (permissions.length === 0) {
      errors.onForm = t("teamMembers.add.error.noPermission");
    }

    return errors;
  }

  isDisabled(perm) {
    if (this.state.domainRelatedPermissions.includes(perm) && !this.props.formData.see_domains) {
      return true;
    } else if (
      this.state.archiveRelatedPermissions.includes(perm) &&
      !this.props.formData.see_vault_email_accounts
    ) {
      return true;
    } else {
      return false;
    }
  }

  submitForm(e) {
    const {
      formData,
      setFormLoading,
      refreshTeamMembers,
      unsetFormLoading,
      setFormErrors
    } = this.props;
    setFormLoading();

    const errors = this.validate(formData);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      unsetFormLoading();
    } else {
      let data = Object.assign({}, formData);
      let permissions = [];
      this.state.permissions.forEach(perm => {
        if (data[perm.name]) permissions.push(perm.name);
        delete data[perm.name];
      });

      data.permissions = permissions;

      const api = new QboxmailApi({ useCookie: true });
      api
        .createTeamMember(data)
        .then(() => {
          refreshTeamMembers();
          this.props.setFormErrors({});
          alertSuccess(t("alert.teamMemberCreatedSuccess"));
          this.resetAndGoBack();
        })
        .catch(response => {
          console.log();
          formatServerErrors(response).then(errors => {
            this.props.setFormErrors(errors);
            this.props.unsetFormLoading();
          });
        });
    }
  }

  resetAndGoBack() {
    this.props.resetForm();
    this.backToList();
  }

  fillPasswordFields(generatedPassword) {
    this.props.setFormFieldValue({
      password: generatedPassword,
      password_confirmation: generatedPassword
    });
  }

  handleCustomerSelection(val) {
    this.props.setFormFieldValue({ customer_code: val ? val.value : null });
  }

  showStepNumber(no) {
    return this.state.steps[no];
  }

  goToStep(no) {
    this.setState({ currentStep: no });
  }

  goBack() {
    if (this.state.currentStep <= 1) return;
    this.setState({ currentStep: this.state.currentStep - 1 });
  }

  render() {
    let toShow = this.showStepNumber(this.state.currentStep);

    return (
      <div className="contentWrapper">
        {React.cloneElement(toShow.component, {
          ...this.props,
          goToStep: this.goToStep,
          submitForm: this.submitForm,
          isLoggedUserAdmin: this.context.isLoggedUserAdmin(),
          backToList: this.backToList,
          goBack: this.goBack,
          permissions: this.state.permissions,
          stepper: <Stepper steps={5} active={this.state.currentStep} goBack={this.goBack} />,
          isDisabled: this.isDisabled,
          domainRelatedPermissions: this.state.domainRelatedPermissions,
          archiveRelatedPermissions: this.state.archiveRelatedPermissions
        })}
      </div>
    );
  }
}

//TeamMemberNewScreen.propTypes = propTypes;
TeamMemberNewScreen.contextTypes = ContextTypes;

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => {
  return {
    refreshTeamMembers: queryParams =>
      dispatch(resActions.callApi("refreshTeamMembers", "teamMembers", queryParams))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormState(TeamMemberNewScreen, formInitialState));
